/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import type { DetailPageProps } from "$src/core/pages/DetailPage/types";
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => React.FC<DetailPageProps>>({
  tv: () => require("./DetailPage.tv").default,
  default: () => require("./DetailPage").default,
})();
